module.exports = __webpack_public_path__ + "img/product-smoke-66.7507f44a.jpg";